// extracted by mini-css-extract-plugin
export default {"conversationHeader":"BoxContainer_conversationHeader__989TZ","pageTitle":"BoxContainer_pageTitle__xmcbn"};